<template>
  <div>
  <nav class="navbar navbar-expand-lg navbar-light fixed-top" :class="scrollPosition > 0 || show || !color ? show ? 'bg-menu' : 'bg-black' : 'bg-colornav'">
    <div class="container pl-md-3">
      <NuxtLink v-if="!show" class="navbar-brand text-white" style="padding-top: 0px; padding-bottom: 0px;" to="/">
        <div class="row" style="display: flex;">
			 
              <span class="pointer mb-md-0 mb-3" style="height:0px;">
              <!--<NuxtLink to="/">--><img :alt="company" class="img-fluid mr-md-3 mb-md-0 mb-3" style="height:50px;" :src="require(`@/assets/images/fitclogo.svg`)"><!--</NuxtLink>-->
              </span>
			  
              <div style="margin-top: 10px;"> 
                 <span style="vertical-align: bottom; font-size:1.4em; font-weight: bold;">{{ company }}</span>
                 <!--<span style="vertical-align: bottom; font-size:1.4em; font-weight: bold;">Q</span>-->
              </div>
        </div>
      </NuxtLink>
      <!--<a v-if="!show" @click="toggleNavbar()" class="navbar-toggler border-0" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon font-size-15"></span>
      </a>-->
      <div class="navbar-collapse" :class="show ? 'navbar-collapse-height overflow-hidden' : 'collapse'" id="navbarNavDropdown">
        <!--<ul class="navbar-nav ml-auto text-center menu-margin">
          <li class="nav-item active px-4 sub-menu-margin">
            <a class="nav-link text-white font-size-20 pointer" @click="$emit('goto-content', 'home'), show = false">Home <span class="sr-only">(current)</span></a>
          </li>
          <li class="nav-item px-4 sub-menu-margin">
            <a class="nav-link text-white font-size-20 pointer" @click="$emit('goto-content', 'about'), show = false">About</a>
          </li>
          <li class="nav-item px-4 sub-menu-margin">
            <a class="nav-link text-white font-size-20 pointer" @click="$emit('goto-content', 'apps'), show = false">Apps</a>
          </li>
          <li class="nav-item pl-md-4 sub-menu-margin">
            <button :class="show ? 'bg-white text-black btn-lg' : 'lime-background text-white'" class="btn rounded-0 font-size-20" @click="$emit('goto-content', 'home'), show = false">Download</button>
          </li>
           <li v-if="show" class="nav-item close-menu-margin">
            <img @click="show = false" class="image-fluid" :src="require(`@/assets/images/close.png`)" alt="">
          </li>
        </ul>-->
      </div>
    </div>
  </nav>
  <div :style="[!color && {'margin-bottom': '80px'}]"></div>

  </div>
</template>
<script>
export default {
  props: ['color'],
  data() {
    return {
      scrollPosition: null,
      show: false,
      company: process.env.company
    }
  },
  methods: {
    updateScroll() {
       this.scrollPosition = window.scrollY
    },
    toggleNavbar() {
      //this.show = !this.show;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.updateScroll);
  }
}
</script>
<style scoped>
  .bg-colornav {
    background: #212121;
  }
  .navbar-toggler-icon{
    display:none;
  }
  .logo-line-height {
    line-height: 1.7;
  }
  .bg-black {
    background-color: #000;
  }
  .lime-background {
    background-color: #8BC34A;
  }
  .font-size-20 {
    font-size: 20px;
  }
  .font-size-30 {
    font-size: 30px;
  }
  .font-size-15 {
    font-size: 15px;
  }
  .pointer {
    cursor: pointer
  }
  .navbar-toggler-icon{
    background-image: url('../assets/images/menu.png') !important;
    }
    .navbar-collapse-height {
    height: 100vh;
}
.bg-menu {
  background: url('../assets/images/menu-bg.png') no-repeat center center;
  background-color: #212121;
  background-size: cover;
}

@media only screen and (max-width: 991px) {
.menu-margin {
  margin-top: 60px
}
.sub-menu-margin {
  margin-top: 25px
}
.close-menu-margin {
  margin-top: 75px
}
}
</style>
